module.exports = __webpack_public_path__ + "img/f431401.png";